import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=bb0f6438&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"
import style0 from "./couponList.vue?vue&type=style&index=0&id=bb0f6438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0f6438",
  null
  
)

export default component.exports